import axios from "axios";

// redirect default API for rest countries
export default axios.create({
    baseURL: "https://restcountries.com/v3.1"
});